import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import Form from '../../Form';
import Row from '../../Row';
import Col from '../../Col';
import File from '../../File';
import Icon from '../../Icon';
import Diagnosis from '../../Diagnosis/Diagnosis';
import Input from '../../Input';
import Textarea from '../../Textarea';
import Button from '../../Button';
import Loader from '../../Loader';
import { upload } from '../../../helpers/upLoadHelper';
import { selectAuthenticatedUser } from '../../../store/selectors/auth';
import { selectFormLoader } from '../../../store/selectors/FormLoader';
import { updateServiceRequest } from '../../../store/actions/serviceRequest';
import { fetchWalkThroughServiceList } from '../../../store/actions/easyWalkThroughForm';
import Overlay from '../../Overlay';
import {  convertImgToBase64 } from '../IndexDB';

import Marker from '../../AnnotateImage/Marker';
import { variables } from '../../../Tenants';
import { onCheckHeicDocument } from '../../../helpers/CommonHelpers';
import CreatableSelect from "react-select/creatable";
import { onCheckUserCanAccessTheModule } from '../../../helpers/validationHelper';
import { S3BucketConfig, USER_ROLES } from '../../../common/constants';


class ServiceRequestEditForm extends Component {
  state = {
    selectedImage: [],
    atFirst: true,
    subject:'',
    description:'',
    showOverlay:false,
    annotateImage:false,
    tags: []
  }

  componentDidUpdate() {
    const { serviceRequest } = this.props;
    if(serviceRequest && serviceRequest.id) {
      if(serviceRequest.attachment && serviceRequest.attachment.length > 0 && this.state.atFirst === true) {
        let selectedImage;
        if(serviceRequest && serviceRequest.edit) {
          selectedImage = JSON.parse(serviceRequest.attachment)
        } else {
          selectedImage = JSON.parse(serviceRequest.attachment)
        }

        this.setState({
          selectedImage: selectedImage,
          atFirst: false,
          subject:serviceRequest.subject,
          description:serviceRequest.description
        })
        this.setTags(serviceRequest.tags);
      } else if(this.state.atFirst === true) {
        this.setState({
          selectedImage: [],
          atFirst: false,
          subject:serviceRequest.subject,
          description:serviceRequest.description
        })
        this.setTags(serviceRequest.tags);
      }
      }
  }

  setTags = (tags) => {
    let selectedtags = [];
    if(tags && tags.length > 0) {
      tags.map(tag => {
        selectedtags = [...selectedtags, {value: tag.id, label: tag.name}]
      })
    }
    this.setState({ tags: selectedtags})
  }

  onSetTags = (newValue, actionMeta) => {
    this.setState({
      tags: newValue
    })
  }
  upLoadImage = async (files) => {
    let upLoadedImages = []
    if (files && files.length > 0) {
        for (var i = 0; i < files.length; i++) {
            let data = await convertImgToBase64(files[i])
            upLoadedImages.push(data)
        }
        return upLoadedImages;
    }
}

  selectMultipleItems = async(files) => {
    let { selectedImage } = this.state;
    if (selectedImage && selectedImage.length) {
        this.setState({ imageLoading:true})
        let upLoadedImages = await this.upLoadImage(files)
        this.setState({imageLoading:false})
        this.setState({ selectedImage: [...upLoadedImages, ...selectedImage] })
        if(this.state.annotateImage === true){
          this.setState({showOverlay:true})
        }
      } else {
          this.setState({ imageLoading:true})
          let upLoadedImages = await this.upLoadImage(files)
          this.setState({imageLoading:false})
          this.setState({ selectedImage: upLoadedImages })
          if(this.state.annotateImage === true){
            this.setState({showOverlay:true})
          }
    }
  }

  handleDelete(item, i) {
    let { selectedImage } = this.state;
    selectedImage = selectedImage.filter(data => data && data.id ? (data.id !== item.id) : data !== item)
    this.setState({ selectedImage:selectedImage })
  }

  onSave = async() =>{
    let  { serviceRequest,onUpdateServiceRequest,user,onClose,walkThroughSignatureList } = this.props;
    let { selectedImage,subject,description, tags } = this.state;
    let serviceRequestTagging = [];

    if(selectedImage && selectedImage.length > 0){
        let profileImage = []
        for(var i=0;i< selectedImage.length;i++){
          if(selectedImage[i] && selectedImage[i].path){
            profileImage[i] =  await upload(selectedImage[i])
          }
        }
        selectedImage = selectedImage.filter(data => {
          if(data.path){
            
          }else{
            return data
          }
        })

        if(tags && tags.length > 0) {
            Promise.all(tags.map(tag => {
              if(tag.__isNew__) {
                serviceRequestTagging = [...serviceRequestTagging, {name: tag.value}]
              } else {
                serviceRequestTagging = [...serviceRequestTagging, {id: tag.value}]
              }
            }))
          }
        selectedImage = [...selectedImage,...profileImage]
        let attachment = JSON.stringify(selectedImage).toString()
        serviceRequest = { ...serviceRequest, attachment}
        let params = {
          "id": serviceRequest.id,
          "subject": subject,
          "description": description,
          "Attachment": JSON.stringify(selectedImage).toString(),
          "issueType": serviceRequest.issueType.name,
          "issueTypeId": serviceRequest.issueType.id,
          "creatorId":user.id,
          "tags": serviceRequestTagging
        }
        onUpdateServiceRequest(params)
        onClose(walkThroughSignatureList)      
    }else{
      let attachment = []
        serviceRequest = { ...serviceRequest, attachment, description, subject}
      let params = {
        "id": serviceRequest.id,
        "subject": subject,
        "description": description,
        "Attachment": JSON.stringify(selectedImage).toString(),
        "issueType": serviceRequest.issueType.name,
        "issueTypeId": serviceRequest.issueType.id,
        "creatorId":user.id,
        "tags": serviceRequestTagging
      }
      onUpdateServiceRequest(params)
      onClose(walkThroughSignatureList)
    }
  } 

  render() {
    const { serviceRequest, onClose, serviceRequestTags } = this.props;
    const { selectedImage,subject,description, tags } = this.state;
    
    const isEnabled = onCheckUserCanAccessTheModule([USER_ROLES.SUPER_ADMIN,USER_ROLES.ADMIN,USER_ROLES.PROPERTY_DEVELOPER]);

    return (
      <Form
        onClose={() => onClose()}
        headline={`Edit ${variables.serviceRequest} Form`}
        strapline=''
        actions={(
          <>
            { serviceRequest.suite && serviceRequest.suite.number ? 
            <Button
              color="teal"
              size="small"
              label={`Save ${variables.serviceRequest}`}
              disabled={!subject || !description}
              onClick={()=> this.onSave()}
            /> : null
          }
          </>
        )}
        component={
          serviceRequest.suite && serviceRequest.suite.number && this.state.atFirst !== true ?
            (
              <Row mdCenter>
                { this.state.imageLoading === true  ? <Loader center={true}/> : null}
                <Col
                  xs="12"
                  md="6"
                >
                  <Diagnosis
                    asset={serviceRequest.assetName ? serviceRequest.assetName : serviceRequest.asset.item.name}
                    issueType={serviceRequest.serviceType ? serviceRequest.serviceType : serviceRequest.issueType.name}
                  />
                  <Row>
                    <Col
                      xs="12"
                      md="6"
                    >
                      <Input
                        label="Property"
                        value={serviceRequest.suite.property.name}
                        disabled
                        block
                      />
                    </Col>
                    <Col
                      xs="12"
                      md="6"
                    >
                      <Input
                        label={variables.Suite}
                        value={serviceRequest.suite.number}
                        disabled
                        block
                      />
                    </Col>
                  </Row>
                  <Textarea
                    required
                    label="Description"
                    placeholder="Add details so we can understand the issue better."
                      onChange={e => this.setState({ description: e.target.value })}
                    value={description}
                    block
                  />
                  <File
                    label="Attachment"
                    onSelect={(file) => onCheckHeicDocument(file) && this.selectMultipleItems(file)}
                    files={[]}
                    multiSelect={true}
                  />
                   <div className='propertyWalkThroughForm__mobileSave' 
               onClick={()=> this.onSave()}
            >
              Save {variables.serviceRequest}
            </div>

                  {selectedImage && selectedImage.length > 0 ?
                    selectedImage.map((data, i) => data.isDeleted === true ? null : (

                      <Row >
                        <Col
                          granola

                          xs="12"
                          md="9"
                        >
                          {data && data.path ? data.path : data.id ? data.id : data.split(S3BucketConfig.url)[1] ? data.split(S3BucketConfig.url)[1] : 'document'+ i.toString()}
                        </Col>

                        <Col granola xs='12' md='3'>
                          <div onClick={() => this.handleDelete(data, i)}>
                            <Icon
                              glyph="times-circle"
                              weight="light"
                              size="small"
                            />
                          </div>
                        </Col>
                      </Row>
                    )
                    ) : null}
                    {isEnabled && 
                    <div style={{marginHorizontal: 20, height: 400}}>
                 <label class="textarea__label">Tags</label>
                 <CreatableSelect
                    placeholder="Add or create tags"
                    closeMenuOnSelect={false}
                    isClearable
                    isMulti
                    options={
                      serviceRequestTags.length > 0
                        ? serviceRequestTags.map(item => ({
                          value: item.id,
                          label: item.name
                        }))
                        : []
                    }
                    value={
                      tags
                    }
                    onChange={(newValue, actionMeta) =>
                      this.onSetTags(newValue, actionMeta)
                    }
                  />
</div>}
                </Col>
                          <Overlay
                    showOverlay={this.state.showOverlay}
                    content={(
                        <Marker
                        onClose={() => this.setState({ showOverlay: false })}
                        images={this.state.selectedImage}
                        onSaveImagesAnotated={(images) => { this.setState({selectedImage:images,showOverlay:false}) }}
                    />
                    )}
                />
              </Row>
              
            )
            :
            <Loader center={true} />
        }
      />
    )
  }
}

const mapStateToProps = (state) => ({
  serviceRequest: state.serviceRequest,
  user: selectAuthenticatedUser(state),
  loader: selectFormLoader(state),
  serviceRequestTags: state.formOptions.serviceRequestTags
});


const mapDispatchToProps = dispatch => bindActionCreators({
  onUpdateServiceRequest:updateServiceRequest,
  onFetchWalkThroughServiceList:fetchWalkThroughServiceList,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestEditForm);